import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { Box, IconButton, PixelPlaceholderLoader } from "@similarweb/ui-components";

import { Icon as BoxTitleIcon } from "pro-features/components/BoxTitle/src/BoxTitle";
import { SearchContainer } from "app/pages/workspace/StyledComponent";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

const MetricContainer = styled(Box)<{ width?: string; height?: string; minWidth?: string }>`
    position: relative;
    ${({ width = "33.3%" }) => `width:${width}`};
    ${({ height = "auto" }) => `height:${height}`};
    ${({ minWidth }) => minWidth && `min-width: ${minWidth}`};
    background-color: white;
    overflow: hidden;
    margin-bottom: 48px;
`;

export const MetricContainerStyled = styled(MetricContainer)`
    overflow: unset;
    width: 100%;
`;

export const OptionButtonsContainer = styled(FlexRow)`
    align-items: center;
    button {
        margin-left: 8px;
    }
`;

export const TableWrapper = styled.div`
    width: 100%;
    & .css-sticky-header {
        top: 0px !important;
    }
    .DropdownContent-container {
        width: 100% !important;
        margin-top: 56px !important;
    }
    .active-row-clicked {
        height: 140px;
    }
`;

export const OptionButton = styled(IconButton)`
    margin-right: 0px;
    svg path {
        fill-opacity: 1;
    }
`;

export const ActivationSetLeaderCell = styled(FlexRow)`
    align-items: center;
    width: 100%;
    height: 100%;
`;

export const ActivationSetLeaderCellContent = styled.span<{ $isDomain?: boolean }>`
    ${({ $isDomain }) => setFontVariant("body2", colorsPalettes.carbon[$isDomain ? 500 : 400])}
`;

export const ActivationSetLeaderCellDomain = styled(ActivationSetLeaderCellContent)`
    max-width: 70%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-right: auto;
`;

export const RECOMMENDATIONS_BODY_HEIGHT = 82;

export const MonitorKeywordsTableTopBarContainer = styled.div`
    display: flex;
    align-items: center;
`;

export const SearchContainerWrapper = styled(SearchContainer)<{ hideBorder: boolean }>`
    flex-grow: 1;
    padding-right: 16px;
    border-top-width: ${({ hideBorder }) => (hideBorder ? 0 : 1)};
`;

export const Right = styled.div`
    flex-grow: 0;
    display: flex;
    align-items: center;
    margin-left: 10px;
`;

export const MonitorKeywordsSuggestedKeywordsContainer = styled.div`
    margin: 0 16px;
    padding-bottom: 8px;
    display: grid;
`;

export const RecommendationsLoaderContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    grid-template-rows: 1fr 1fr;
    justify-items: center;
    align-items: center;
    height: 100%;
`;

export const PixelPlaceholderLoaderStyled = styled(PixelPlaceholderLoader)`
    margin-top: 9px;
`;

export const RecommendationsBody = styled.div`
    max-height: ${RECOMMENDATIONS_BODY_HEIGHT}px;
    overflow: hidden;
`;

export const TooltipContentContainer = styled.div`
    display: grid;
    grid-template-columns: 1fr 25px 1fr;
    padding-left: 4px;
`;

export const TooltipColumn = styled.div<{ withSeparator?: boolean }>`
    display: flex;
    flex-direction: column;
    ${setFontVariant("dataTable2")}
`;

export const TooltipColumnSeparator = styled.div`
    height: 100%;
    margin: 0 12px;
    width: 1px;
    background-color: ${colorsPalettes.carbon[100]};
`;

export const TooltipValue = styled.div`
    margin-top: 2px;
    ${setFontVariant("listItem1")}
`;

export const BoxTitleContainer = styled(FlexRow)`
    height: 48px;
    align-items: center;
    ${setFontVariant("subtitle2")}

    ${BoxTitleIcon} path {
        fill: ${colorsPalettes.carbon[400]};
    }
`;

export const TotalTrafficShareContainer = styled.div`
    margin-top: 24;
    margin-bottom: 27;
    padding: 0 16px;
`;

export const BoxTitleRightAlignedContainer = styled.div`
    margin-left: auto;
    display: flex;
`;
